<h2 class="h6">Passwort</h2>
<p>
  Klicken Sie bitte auf „Passwort ändern“. Sie werden auf eine Seite außerhalb des Mein Konto Bereichs geführt. Hier
  folgen Sie bitte dem Prozess.
</p>
<a [href]="passwordUrl()" (click)="linkClicked.emit()" target="_blank" mat-stroked-button>Passwort ändern</a>
